import React from "react";
import { Link } from "react-router-dom";

const LOUNGE_LOOK = "https://customer-assets.emergentagent.com/job_atelier-tall/artifacts/55qqbuh3_ChatGPT%20Image%20May%2019%2C%202026%2C%2001_08_42%20PM.png";
const ACTIVE_LOOK = "https://customer-assets.emergentagent.com/job_atelier-tall/artifacts/rklzh7kr_ChatGPT%20Image%20May%2019%2C%202026%2C%2001_16_17%20PM.png";

const COLLECTIONS = [
  { title: "Lounge", img: LOUNGE_LOOK, link: "/shop?category=lounge", copy: "Quarter-zips, joggers, rugby tops.", key: "lounge", pos: "center 30%" },
  { title: "Active", img: ACTIVE_LOOK, link: "/shop?category=active", copy: "Stripes, sculpt leggings, bicycle shorts.", key: "active", pos: "center 35%" },
];

export const CollectionsSplit = () => (
  <section className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 py-16 sm:py-24 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-6 lg:gap-12" data-testid="collections-section">
    {COLLECTIONS.map((c, i) => (
      <Link
        to={c.link}
        key={c.key}
        className="group relative block fade-up"
        style={{ animationDelay: `${0.1 + i * 0.15}s` }}
        data-testid={`collection-${c.key}`}
      >
        <div className="relative overflow-hidden bg-[#efe6db] aspect-[3/4]">
          <img src={c.img} alt={c.title} className="img-zoom w-full h-full object-cover" style={{ objectPosition: c.pos }} />
        </div>
        <div className="mt-6 flex justify-between items-end">
          <div>
            <div className="micro-label text-[#1a1814]/60">Collection</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1a1814] mt-2">{c.title}</h2>
            <p className="text-sm italic text-[#1a1814]/70 mt-2">{c.copy}</p>
          </div>
          <div className="micro-label text-[#1a1814] underline underline-offset-8 decoration-[0.5px]">Discover</div>
        </div>
      </Link>
    ))}
  </section>
);
